import React from 'react';
import { components } from 'react-select';

/**
 * Defines a MenuList component to be used with React-Select. This component adds
 * a search box atop the menu dropdown. The base MenuList component is left unaltered
 * otherwise.
 */
const MenuList = (all) => {
  const { selectProps, ...props } = all;
  const {
    setIsFocused,
  } = selectProps;
  const { children } = props;

  return (
    <div
      className="has-search"
      onClick={(e) => {
        setIsFocused(true);
        e.stopPropagation();
      }}
      // Add keydown listener to satisfy jsx-ally/click-events-have-key-events
      // ESLint error
      onKeyDown={(e) => {
        setIsFocused(true);
        e.stopPropagation();
      }}
    >
      <components.MenuList
        {...props}
        selectProps={selectProps}
      >
        {children}
      </components.MenuList>
    </div>
  );
};

export default MenuList;
